import {
  IOption,
  IForumThread,
  IMessage,
  INotification,
  IReport,
  ISettings,
  ISubCategory,
  ITherapist,
  IVideo,
  TSendFileForm,
} from "../types/types";
import venchy from "../images/questionnaire_doctor.png";
import { IContactUsTheme } from "./categories";
import { IUserGoal } from "../services/types/goals.types";
import { TSupportMessage } from "../services/types/requests.types";
 import { tWithKeyAttr as t } from "../i18nHelper"; 

 // Accepts:
// - E.164 international: + followed by 8 to 15 digits (e.g., +972501234567)
// - Digits-only international for Israel starting with 972 (8–9 more digits)
// - Israeli local mobile: 05XXXXXXXX (10 digits)
export const phoneRegExp = /^(\+\d{8,15}|972\d{8,9}|05\d{8})$/;

export const phoneNumber = "*3596";
export const BASE_URL =
  window.location.hostname.includes("test") ||
    window.location.hostname.includes("local")
    ? "https://api-test.bpreven.com/"
    : "https://api.bpreven.com/";


export const testUserEmail = "";
export const testUserEmail2 = "";

export const mobileWidth = "(max-width: 600px)";
export const tabletWidth = "(max-width:1200px)";

export const noDataLabel = "אין מידע";

export const phonePrefixOptions = [
  "050",
  "051",
  "052",
  "053",
  "054",
  "055",
  "057",
  "058",
];

export const defaultAvatarLink =
  "https://private-user-images.githubusercontent.com/177111217/406731381-351992b7-8379-4cba-a029-451cf989a3a1.png?jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJnaXRodWIuY29tIiwiYXVkIjoicmF3LmdpdGh1YnVzZXJjb250ZW50LmNvbSIsImtleSI6ImtleTUiLCJleHAiOjE3Mzc5MTMwMDcsIm5iZiI6MTczNzkxMjcwNywicGF0aCI6Ii8xNzcxMTEyMTcvNDA2NzMxMzgxLTM1MTk5MmI3LTgzNzktNGNiYS1hMDI5LTQ1MWNmOTg5YTNhMS5wbmc_WC1BbXotQWxnb3JpdGhtPUFXUzQtSE1BQy1TSEEyNTYmWC1BbXotQ3JlZGVudGlhbD1BS0lBVkNPRFlMU0E1M1BRSzRaQSUyRjIwMjUwMTI2JTJGdXMtZWFzdC0xJTJGczMlMkZhd3M0X3JlcXVlc3QmWC1BbXotRGF0ZT0yMDI1MDEyNlQxNzMxNDdaJlgtQW16LUV4cGlyZXM9MzAwJlgtQW16LVNpZ25hdHVyZT1mODQzOWZlNDc0OTJiMmVmYTZiMWIyNjU1NjlhZThlZGFjMzY4YmFjNDAzNTliYzkwYWFmOTEzNzBlYmZjNzdiJlgtQW16LVNpZ25lZEhlYWRlcnM9aG9zdCJ9.q6RjG1jdI-QkTa0NkzxL37hdbawliGYOkNIB_Jv8hDM";

export const customerService = "customerService";
export const israeliMobileRegExp = /^(05\d|9725\d)([-]?)\d{7}$/;
export enum appointmentOptions {
  Cancel = "cancel",
  Update = "update",
  Create = "create",
}

export const defaultSettings: ISettings = {
  sendToEmail: true,
  sendAds: true,
  sendNotifications: true,
};

export const cardInitialState = {
  cardNumber: "",
  cardUser: "",
  cvv: null,
  exp: "",
};
export const minCardNumberLength = 12;
export const cvvLength = 3;

export const charMax = 400;

export const questions: IContactUsTheme[] = [
  {
    title: "האם הפסיכולוגים שלכם מוסמכים?",
    text: "גישה רק לדברים החיוניים ביותר. שדרג לפרימיום וקבל שירותי תמיכה נפשית על ידי פסיכולוג מוסמך זמין 24/7, התייעצות בפורום עם מתמודדים כמוך, ועודגישה רק לדברים גישה רק לדברים החיוניים ביותר. שדרג לפרימיום וקבל שירותי תמיכה נפשית על ידי פסיכולוג מוסמך ",
  },
  {
    title: "האם הפסיכולוגים שלכם מוסמכים?",
    text: "שלכם שלכם שלכם שלכםשלכםשלכם שלכם שלכם שלכם",
  },
  {
    title: "האם הפסיכולוגים שלכם מוסמכים?",
    text: "שלכם שלכם שלכם שלכםשלכםשלכם שלכם שלכם שלכם",
  },
];

export const messages: IMessage[] = [
  {
    messageId: "1",
    id: "123456",
    date: new Date(),
    message: "מה שלומך?",
    unread: true,
  },
];

export const week = [
  "יום א'",
  "יום ב'",
  "יום ג'",
  "יום ד'",
  "יום ה'",
  "יום ו'",
  "יום ש'",
];

export const videoExample: IVideo[] = [
  {
    link: "https://media.istockphoto.com/id/641530166/video/young-woman-exercising-yoga-by-the-lake-at-sunset.mp4?s=mp4-640x640-is&k=20&c=drbKOmtsa1zx_fAsqLKe2GBI96aqbmnGVwU6rR2lzsw=",
    title: "תרגול מיינדפולנס",
    about:
      "׳קשיבות׳ הוא שמה העברי של שיטת תרגול מדיטטיבי הכרוכה בהפניית הקשב באופן מכוון ובלתי שיפוטי לחוויות ותופעות המתרחשות ברגע. הקשיבות מתוארת כמודעות מכבדת ונטולת שיפוט ׳קשיבות׳ הוא שמה העברי של שיטת תרגול מדיטטיבי הכרוכה בהפניית הקשב באופן מכוון ובלתי שיפוטי לחוויות ותופעות המתרחשות ברגע. הקשיבות מתוארת כמודעות מכבדת ונטולת שיפוט",
  },
  {
    link: "https://media.istockphoto.com/id/1192719321/video/calm-young-african-man-meditate-on-sofa-with-eyes-closed.mp4?s=mp4-640x640-is&k=20&c=uV8ZVhrWA_yrurfcMILSQx17M1pU1j_59PqMRkzSVy8=",
    title: "תרגול מיינדפולנס",
    about: "תרגול מיינדפולנס קצר לשיפור הקשב והריכוז והפחתת חרדה",
  },
  {
    link: "https://media.istockphoto.com/id/1192719321/video/calm-young-african-man-meditate-on-sofa-with-eyes-closed.mp4?s=mp4-640x640-is&k=20&c=uV8ZVhrWA_yrurfcMILSQx17M1pU1j_59PqMRkzSVy8=",
    title: "מיינדפולנס",
    about:
      "מדיטציית מיינדפולנס זוהי מדיטציה המפתחת תשומת לב, ריכוז, קשיבות ומודעות, שמביאה לשינוי באופן שבו אנו חווים את החיים ומלמדת אותנו יכולות התמודדות עם קשיים שהחיים מזמנים, ביניהם התקופה לפני הניתוח וההחלמה לאחר מכן",
  },
];

export const feelVariants = [
  "נפלא, מלא באנרגיה!",
  "מצוין",
  "טוב מאוד",
  "טוב",
  "בסדר",
  "תקופה מאתגרת",
  "לא קל עכשיו",
  "קשה לי",
  "בלתי נסבל",
  "אני חייב עזרה",
];
export const goalsVariants = [
  "ללכת למכון הכושר שלוש פעמים בשבוע",
  "להוריד במינון התרופות",
  "לישון שינה רציפה בלילה",
  "לבצע את כל התרגילים המומלצים לי",
];
export const getHelpVariants = [
  "אני צריך לדבר עם מישהו דחוף",
  "אני צריך מרשם חדש",
  "אני רוצה א",
  "אני רוצה ב",
  "אני רוצה ג",
];

export let initialGoalsVariants: IUserGoal[] = [];

export const prevencherMessages: IMessage[] = [
  {
    messageId: "1",
    id: "1",
    message: "אני תמיד מכשיב לך, איך אתה מרגיש, מ 1 עד 10?",
    date: new Date(),
    unread: false,
  },
];
export const prevencherMessagesSetGoals: IMessage[] = [
  {
    messageId: "1",
    id: "1",
    message:
      "בוא נקבע לך מספר מטרות ונבדוק איך אתה מתקדם איתן לאורך זמן, בסדר? בחר מתוך הרשימה מטרה שנראית לך ברת השגה",
    date: new Date(),
    unread: false,
  },
];
export const prevencherMessagesNewUser: IMessage[] = [
  {
    messageId: "1",
    id: "1",
    message: "הי נתנאל, ברכות על הצטרפותך! יש לי כמה שאלות לפני שנתחיל. מוכן?",
    date: new Date(),
    unread: false,
  },
];
export const prevencherMessagesGetHelp: IMessage[] = [
  {
    messageId: "1",
    id: "1",
    message: "הי נתנאל, על מה תרצה לדבר היום? אנא בחר את הנושא",
    date: new Date(),
    unread: false,
  },
];

export const venchyData: Partial<ITherapist> = {
  id: "venchy",
  name: "וונצ’י",
  avatar: venchy,
};
export const yesNoVariants: string[] = ["כן", "לא"];

export const auxiliaryWords = ["אני", "לא", "יכול", ",", " ", "", "רוצה"];

export enum ContactUsSearchOptions {
  Input = "input",
  List = "list",
}

export const contactUsList: IContactUsTheme[] = [
  {
    title: "CONTACT_UPGRADE_SUBSCRIPTION",
    text: "TEXT_EXAMPLE",
  },
  {
    title: "CONTACT_SUBSCRIPTION_TYPES",
    text: "TEXT_EXAMPLE_2",
  },
  {
    title: "CONTACT_GENERAL_INFO",
    text: "TEXT_EXAMPLE_2",
  },
  {
    title: "CONTACT_REGISTRATION",
    text: "TEXT_EXAMPLE",
  },
  {
    title: "CONTACT_SCHEDULE_EXPERT",
    text: "TEXT_EXAMPLE_2",
  },
  {
    title: "CONTACT_PRESCRIPTIONS_DOCS",
    text: "TEXT_EXAMPLE_2",
  },
];

export const notificationsExample: INotification[] = [
  { unread: true, text: "פנייה חדשה מד״ר נאמן", section: "chat" },
  { unread: true, text: "הופקה עבורך חשבונית חדשה", section: "profile" },
  { unread: true, text: "תגובה לשרשור שפתחת בפורום", section: "chat" },
  { unread: false, text: "פנייה חדשה מנחום, המדריך", section: "chat" },
  { unread: false, text: "התקבל מרשם חדש", section: "treatment" },
];

export const forumThemes = [
  "דיכאון וחרדה",
  "הפרעות שינה",
  "תרופות",
  "מצב רוח",
  "הפרעות אישיות",
];

export const forumExample: {
  id: string;
  title: string;
  avatar: string;
  userName: string;
  date: Date;
  lastMessage: string;
  messages: number;
}[] = [
    {
      id: "123",
      title: "בדיחות על דיכאון, שמחה וששון",
      avatar:
        "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8cGVvcGxlfGVufDB8fDB8fHww&auto=format&fit=crop&w=600&q=60",
      userName: "הצועד בנעליו",
      date: new Date(),
      lastMessage:
        "בואו נעלה בדיחות על דיכאון, אני ראשון: כומר ורבי נפגשים ברבנות בפתח תקווה ",
      messages: 10,
    },
    {
      id: "345",
      title: "מה עושים כשהמחשבות השחורות עולות לפתע?",
      avatar:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fHBlb3BsZXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=600&q=60",
      userName: "אחד מהקהל",
      date: new Date(),
      lastMessage:
        "מה עושים כשהמחשבות השחורות עולות לפתע? למעשה, האויב הגדול ביותר שלנו לא נמצא בחוץ אלא בפנים והוא משפיע על איך אנחנו חווים את המציאות בחוץ.",
      messages: 20,
    },
    {
      id: "12389749326",
      title: "בדיחות על דיכאון, שמחה וששון",
      avatar:
        "https://images.unsplash.com/photo-1495216875107-c6c043eb703f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjN8fHBlb3BsZXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=600&q=60",
      userName: "הצועד בנעליו",
      date: new Date(),
      lastMessage:
        "מה עושים כשהמחשבות השחורות עולות לפתע? בואו נעלה בדיחות על דיכאון, אני ראשון: כומר ורבי נפגשים ברבנות בפתח תקווה ",
      messages: 4,
    },
  ];

export const forumThreadExample: IForumThread = {
  id: "1",
  title: "מה עושים כשהמחשבות השחורות עולות לפתע?",
  messages: [
    {
      id: "2",
      user: {
        userName: "אחד מהקהל",
        avatar:
          "https://images.unsplash.com/photo-1495216875107-c6c043eb703f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjN8fHBlb3BsZXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=600&q=60",
        date: new Date(),
      },
      message:
        "יש המון רעש בחוץ, בסביבה הקרובה והרחוקה שלנו, אבל הרעש המשמעותי ביותר מגיע מתוכנו דרך המחשבות שלנו. למעשה, האויב הגדול ביותר שלנו לא נמצא בחוץ אלא בפנים והוא משפיע על איך אנחנו חווים את המציאות בחוץ." +
        "זו הבעיה הגדולה של כולנו, וכל כך הרבה שיטות ומומחים ביקשו לפתור אותה, אך עד היום לא נמצא לה, לבעיה שמטרידה את האנושות שולה - פתרון.",
    },
    {
      id: "3",
      user: {
        userName: "גל ברקוביץ",
        avatar:
          "https://media.istockphoto.com/id/1386479313/photo/happy-millennial-afro-american-business-woman-posing-isolated-on-white.webp?b=1&s=170667a&w=0&k=20&c=ahypUC_KTc95VOsBkzLFZiCQ0VJwewfrSV43BOrLETM=",
        date: new Date(),
        tag: "מדריך",
      },
      message:
        "הקושי לשלוט במחשבות הוא גדול, אין בכך ספק." +
        "אנחנו לא יכולים לשלוט בהם אבל אנחנו בהחלט יכולים להגיב בצורה חיובית גם למחשבות שליליות.",
    },
    {
      id: "4",
      user: {
        userName: "יובלי",
        avatar:
          "https://media.istockphoto.com/id/1368424494/photo/studio-portrait-of-a-cheerful-woman.jpg?s=612x612&w=0&k=20&c=ISNDV3ZXeNU6VvDhR7KXFd6y0saq4Eji15cep_Gj8Eg=",
        date: new Date(),
      },
      message:
        "אבל גל, ככל שהמחשבות מתחזקות ככה היכולת שלנו להמשיך ולהגיב בצורה חיובית קטנה... אני מרגישה בלופ שלא נגמר",
      replyTo: "3",
    },
  ],
};

export const myReportsSummaryExample: IReport[] = [
  {
    id: "1",
    title: "סיכום פגישה",
    subTitle: "אפריל 2023",
    date: new Date(),
    content: "",
  },
  {
    id: "2",
    title: "סיכום פגישה",
    subTitle: "ספט 22 - מרץ 23",
    date: new Date(),
    content: "",
  },
  {
    id: "3",
    title: "סיכום פגישה",
    subTitle: "מרץ 2023",
    date: new Date(),
    content: "",
  },
];
export const myReportsPeriodExample: IReport[] = [
  {
    id: "1",
    title: "דו״ח התקדמות",
    subTitle: "אפריל 2023",
    date: new Date(),
    content: "",
  },
  {
    id: "2",
    title: "דו״ח התקדמות",
    subTitle: "ספט 22 - מרץ 23",
    date: new Date(),
    content: "",
  },
];

export const filterOptions: ISubCategory[] = [
  { value: "week", title: "השבוע" },
  { value: "lastWeek", title: "שבוע שעבר" },
  { value: "month", title: "החודש" },
  { value: "lastMonth", title: "חודש שעבר" },
  { value: "date", title: "תאריך מסוים" },
];

export const newReportSubjects: ISubCategory[] = [
  { value: "1", title: "נושא אחד" },
  { value: "2", title: "נושא שני" },
  { value: "3", title: "נושא שלישי" },
  { value: "4", title: "נושא רביעי" },
  { value: "5", title: "נושא חמישי" },
];

export const forumCategories: ISubCategory[] = [
  { value: "depression", title: "דיכאון" },
  { value: "anxieties", title: "חרדות" },
  { value: "personalityDisorders", title: "הפרעות אישיות" },
  { value: "sleepDisorders", title: "הפרעות שינה" },
  { value: "moodDisorders", title: "הפרעות מצב רוח" },
  { value: "motivation", title: "מוטיבציה" },
  { value: "schizophrenia", title: "סכיזופרניה" },
  { value: "generalDistress", title: "מצוקה כללית" },
  { value: "other", title: "אחר" },
];

export const genderOptions: { id: number; name: string }[] = [
  {
    id: 1,
    name: "זכר",
  },
  {
    id: 2,
    name: "נקבה",
  },
  {
    id: 3,
    name: "לא מוגדר",
  },
  {
    id: 4,
    name: "אחר",
  },
];
export const countryOptions: string[] = ["ישראל", "ארצות הברית", "קנדה"];

export const allUsersFlows = [
  {
    id: 1,
    symbol: "U1",
    desc: "משתמש אורח",
    statusId: 1,
  },
  {
    id: 3,
    symbol: "U2",
    desc: "משתמש רשום",
    statusId: 1,
  },
];
export const existingUserFlowId = 3;
export const guestUserFlowId = 1;

export const docsCategories: ISubCategory[] = [
  { value: "", title: "SELECT_DOC_CATEGORY"},
  { value: "diagnoses", title: "DIAGNOSES"},
  { value: "prescriptions", title: "PRESCRIPTIONS" },
  { value: "applications", title: "APPLICATIONS" },
  { value: "summaries", title: "SUMMARIES" },
  { value: "other", title: "OTHER" },
];

export const applicationDetails: ISubCategory[] = [
  { value: "", title: "SELECT_APPLICATION_DETAILS" },
  { value: "newPrescription", title: "NEW_PRESCRIPTION" },
  { value: "newApplication", title: "NEW_APPLICATION" },
  { value: "other", title: "OTHER" },
];
export const urgencyVariants: ISubCategory[] = [
  { value: "", title: "SELECT_URGENCY_PROMPT" },
    { value: "1", title: "LOW"},
    { value: "2", title: "MEDIUM" },
    { value: "3", title: "HIGH" },
];

export const sendFileFormInitialValue: TSendFileForm = {
  category: docsCategories[0],
  details: applicationDetails[0],
  urgent: urgencyVariants[0],
  file: null,
};

export const INACTIVITY_TIMEOUT = 18 * 60 * 1000; // 18 minutes until logout
export const WARNING_TIMEOUT = 15 * 60 * 1000; // 15 minutes until warning
// export const INACTIVITY_TIMEOUT = 2 * 60 * 1000; // for test
// export const WARNING_TIMEOUT = 1 * 60 * 1000; // for test

export const WARNING_DURATION = 60 * 1000;
export const formatCountdown = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(
    remainingSeconds
  ).padStart(2, "0")}`;
};

export const TYPING_CODE = "TYPING_CODE";
export const END_CALL_CODE = "END_CALL_CODE";
export const END_APPOINTMENT = "END_APPOINTMENT";

export const chatNoteTypes = {
  isTyping: "isTyping",
  text: "text",
} as const;

export const cancelAppointmentResaonsLocal: IOption[] = [
  { value: "medical", label: "סיבה רפואית" },
  { value: "technica;", label: "סיבה טכנית" },
  { value: "familyEvent", label: "אירוע משפחתי" },
  { value: "personal", label: "סיבה אישית" },
  { value: "stopTreatment", label: "הפסקת טיפול" },
  { value: "other", label: "אחר", isCustom: true },
];

export const supportMessageInitialState: TSupportMessage = {
  screenType: 1,
  subject: "",
  body: "",
};

// IMPORTANT: Do NOT compute translations at module load.
// Compute at call-time so i18n resources are ready.
export const getMyDayUpdates = () => ([
  {
    title: t("YOU_ARE_NOT_ALONE_SEEKING_HELP_IS_STRENGTH_NOT_WEAKNESS") as unknown as string,
    desc: t("SOMETIMES_FEELINGS_OF_EMOTIONAL_LONELINESS_CAN_MAKE_US_THINK_WE_ARE_ALONE_IN_OUR_STRUGGLE_BUT_THE_TRUTH_IS_THAT_THERE_ARE_PEOPLE_AROUND_YOU_WHO_WANT_TO_HELP_FAMILY_MEMBERS_FRIENDS_OR_PROFESSIONALS_IF_YOU_ARE_FEELING_OVERWHELMED_OR_STRUGGLING_TO_COPE_DO_NOT_HESITATE_TO_REACH_OUT_TO_SOMEONE_CLOSE_OR_TO_A_SPECIALIST_IN_THE_FIELD_THE_RIGHT_SUPPORT_CAN_BE_THE_DIFFERENCE_BETWEEN_BEING_STUCK_AND_MAKING_PROGRESS") as unknown as string,
  },
  {
    title: t("YOUR_FEELINGS_ARE_VALID_IT_IS_OKAY_TO_FEEL_EVERYTHING") as unknown as string,
    desc: t("SOMETIMES_WE_TRY_TO_SUPPRESS_DIFFICULT_EMOTIONS_OUT_OF_FEAR_GUILT_OR_DISCOMFORT_BUT_EVERY_EMOTION_WHETHER_POSITIVE_OR_NEGATIVE_IS_LEGITIMATE_AND_CARRIES_AN_IMPORTANT_MESSAGE_INSTEAD_OF_FIGHTING_IT_TRY_TO_UNDERSTAND_IT_ASK_YOURSELF_WHAT_IS_THIS_EMOTION_TRYING_TO_TELL_ME_WHAT_THOUGHT_LIES_BEHIND_IT_SELF_UNDERSTANDING_CAN_TURN_DIFFICULTY_INTO_AN_OPPORTUNITY_FOR_GROWTH") as unknown as string,
  },
  {
    title: t("ONE_BREATH_CAN_CHANGE_EVERYTHING_GIVE_YOUR_BODY_A_MOMENT_TO_RELAX") as unknown as string,
    desc: t("WHEN_YOU_FEEL_TENSION_PRESSURE_OR_ANXIETY_STOP_FOR_A_MOMENT_AND_BREATHE_DEEPLY_INHALE_AIR_SLOWLY_THROUGH_YOUR_NOSE_HOLD_IT_FOR_TWO_SECONDS_AND_EXHALE_SLOWLY_THROUGH_YOUR_MOUTH_REPEAT_THE_EXERCISE_3_TO_5_TIMES_SIMPLE_BREATHING_TECHNIQUES_CAN_REGULATE_THE_NERVOUS_SYSTEM_REDUCE_ANXIETY_AND_HELP_YOU_GAIN_MENTAL_CLARITY_EVEN_DURING_MOMENTS_OF_EMOTIONAL_OVERWHELM") as unknown as string,
  },
  {
    title: t("EVEN_SMALL_STEPS_CREATE_BIG_CHANGE") as unknown as string,
    desc: t("CHANGE_DOES_NOT_HAPPEN_IN_ONE_DAY_AND_THAT_IS_OKAY_IF_YOU_FEEL_STUCK_TRY_TO_FOCUS_ON_ONE_SMALL_ACTION_YOU_CAN_DO_TODAY_FOR_YOURSELF_WHETHER_IT_IS_GOING_FOR_A_SHORT_WALK_WRITING_DOWN_ONE_POSITIVE_THOUGHT_OR_SIMPLY_REMINDING_YOURSELF_THAT_YOU_ARE_ACTING_FOR_YOUR_OWN_GOOD_REAL_PROGRESS_COMES_FROM_PERSISTENCE_IN_SMALL_STEPS_AND_THESE_ARE_WHAT_BUILD_MEANINGFUL_CHANGE_OVER_TIME") as unknown as string,
  },
]);

export enum DataTypes {
  Options = 1,
  Text = 2,
  Number = 3,
  Date = 4,
  AutoAdvance = 5,
  Voice = 6,
  File = 7,
  AI = 8,
}
export const maxFileSizeMB = 10;
